var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Gigaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.79 37.24a36.54 36.54 0 01-9 24.08l-3-2.64a32.58 32.58 0 000-42.88l3-2.63a36.53 36.53 0 019 24.07zM59.15 19.58L56 22a25 25 0 010 30.43l3.16 2.44a29 29 0 000-35.32l-.01.03zm-3.36 8l-3.58 1.77a17.88 17.88 0 010 15.76l3.58 1.77a21.82 21.82 0 000-19.3zM47 37.24a6 6 0 01-5 5.91v11.09A2.001 2.001 0 0140.9 56a2 2 0 01-.9.21 2 2 0 01-1.2-.4L25.65 46H21v10a3 3 0 01-6 0V46h-5a8.75 8.75 0 01-8-8.71 9.3 9.3 0 018-9.18V28h15.68l13.16-9.39A2 2 0 0142 20.24v11.09a6 6 0 015 5.91zm-9-13.11l-10.52 7.5a2 2 0 01-1.16.37H11a5.19 5.19 0 00-5 5.24A4.77 4.77 0 0011 42h15.32a2 2 0 011.2.4L38 50.25V24.13z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Gigaphone.f97b5af4.svg";
export { SvgH1Gigaphone as ReactComponent };